import React, {Component} from 'react';
import { connect } from 'react-redux';
import Utils from 'utils/Utils.js';

import DatabaseService from 'services/DatabaseService.js';
import {initNavbarState} from 'actions/navbar.js';
import {getUserPluginsByTypeTag} from 'reducers/userPlugins.js';
import SurveyContainer from 'modules/surveys/SurveyContainer.js';
import {NavControl} from 'modules/navigation/NavBarContainer.js';
import LoadInline from 'modules/loading/LoadInline.js';

import GroupSelectContainer from 'modules/authentication/GroupSelectContainer.js';


const Pages = [
    {
        tag:'onboardingSurvey',
        enabled(state) {
            return Boolean(state.surveys.onboarding && state.surveys.onboarding.id); 
        }
    }
];



class OnboardingContainer extends Component {
    constructor(props) {
        super(props);
        var onboardingContainerInitialState = {
            state:{stepno:0},
            pages:null,
            surveys:null
        };
        this.resumeState(onboardingContainerInitialState);
        this.state = onboardingContainerInitialState.state;
        this.pages = onboardingContainerInitialState.pages;
        this.next = this.next.bind(this);
        this.skip = this.skip.bind(this);
        this.prev = this.prev.bind(this);
        this.onChangeStep = this.onChangeStep.bind(this);
        this.onOnboardingSurveyCompleted = this.onOnboardingSurveyCompleted.bind(this);
        if(this.surveys===null || (typeof this.surveys)!=='object') {
            this.surveys = DatabaseService.getSurveysCache();
        }
        console.log('OnboardingContainer surveys=', this.surveys);
    }

    componentWillMount() {
        if(!this.pages && this.props.dataLoaded) {
            this.buildPages({...this.props, surveys:this.surveys});
        }
        this.props.dispatch(initNavbarState({enable:true, mode:'light', backButtonEnable:true}));
    }

    componentWillReceiveProps(nextProps) {
        if(!this.pages && !this.props.dataLoaded && nextProps.dataLoaded) {
            this.buildPages({...nextProps, surveys:this.surveys});
        }
    }

    buildPages(state) {
        var pages = [];
        if(sessionStorage.onboardinPages) {
            pages = JSON.parse(sessionStorage.onboardinPages);
        } else {
            var pages = Pages.filter(page => page.enabled(state)).map(page => page.tag);
        }

        if(pages.length==0) {
            console.log('OnboardingContainer - no onboarding pages -> redirecting to /home');
            this.props.history.push('/home');
        }
        this.pages = pages;

        var stepno = this.state.stepno;
        var pageTag = this.getPageTag(stepno);
    }


    onChangeStep() {
        var stepno = this.state.stepno;
        this.preserveState();
        var pageTag = this.getPageTag(stepno);
    }


    preserveState() {
        var onboardingContainerState = {state:this.state, pages:this.pages, surveys:this.surveys};
        sessionStorage.onboardingContainerState = JSON.stringify(onboardingContainerState);
    }

    resumeState(initialState) {
        if(sessionStorage.onboardingContainerState) {
            var onboardingContainerState = JSON.parse(sessionStorage.onboardingContainerState);
            if(onboardingContainerState.pages && 
               onboardingContainerState.state &&
               onboardingContainerState.surveys) {
                initialState.surveys = onboardingContainerState.surveys;
                initialState.pages   = onboardingContainerState.pages;
                initialState.state   = onboardingContainerState.state;
                initialState.state.resumed = true;
            }
            delete sessionStorage.onboardingContainerState;
        }
    }

    next() {
        this.seek(1);
    }

    skip() {
        this.seek(2);
    }

    seek(num) {
        var nextStepNo = this.state.stepno+num;
        if(nextStepNo >= this.pages.length) {
            delete sessionStorage.onboardingContainerState;
            this.props.history.push('/home');
        } else {
            this.setState({stepno:nextStepNo}, this.onChangeStep);
        }
    }

    prev() {
        this.setState({stepno:this.state.stepno-1}, this.onChangeStep);
    }

    getPageTag(stepno) {
        return this.pages[stepno];
    }

    onOnboardingSurveyCompleted() {
        var surveys = this.surveys || {};
        surveys.onboarding = null;
        DatabaseService.setSurveysCache(surveys)
        this.next();
    }

    getContent(stepno) {

        if(!this.props.dataLoaded || !this.pages) {
            return <LoadInline centered vcentered />;
        }

        var key = 'onboarding' + stepno;
        var closeIconOpts = {key:key, name:'chevron left'};
        var start = stepno===0;

        var pageTag = this.getPageTag(stepno);
        switch(pageTag) {
            case 'onboardingSurvey':
                return (
                    <SurveyContainer key={key} 
                                     surveyId={this.surveys.onboarding.id}
                                     navMode='light' 
                                     noCompleteScreen
                                     onCompleted={this.onOnboardingSurveyCompleted}
                                     onEmpty={this.onOnboardingSurveyCompleted}
                                     noClose={true}/>
                    );
            default: return null;
        }
        return null;
    }

    render() {
        return this.getContent(this.state.stepno);
    }
}

const mapStateToProps = (state, ownProps) => {
    var dataLoaded = Boolean(state.user.userProfile);
    return {dataLoaded:dataLoaded,
            user:state.user};
}
   
export default connect(mapStateToProps)(OnboardingContainer); 



// WEBPACK FOOTER //
// ./src/modules/onboarding/v2/OnboardingContainer.js